import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { PostRequest } from "../../services/ApiClientService"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { ERequestType } from "../../Enum/ERequestType"
import { useTranslation } from "react-i18next"

export const useAdminEmployeeChangePassword = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleChangePassword = async (id: number, newPassword: string, onSuccess: () => void) => {
    enableLoad()

    try {
      const response = await PostRequest(
        API_ROUTES.ADMIN_EMPLOYEE.CHANGE_PASSWORD(id),
        { newPassword },
        ERequestType.Admin,
      )

      if (response.success) {
        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return { handleChangePassword }
}
